import * as React from 'react';

export const ExampleManifests = () => (
    <>
        You can find manifests <a href='https://github.com/argoproj/argo/tree/master/examples'>in the examples</a> or templates in{' '}
        <a href='https://argoproj-labs.github.io/argo-workflows-catalog/'>Workflow Template Catalog</a>
    </>
);
